const ArrowUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H20.8C21.9201 0 22.4802 0 22.908 0.217987C23.2843 0.409734 23.5903 0.715695 23.782 1.09202C24 1.51984 24 2.0799 24 3.2V20.8C24 21.9201 24 22.4802 23.782 22.908C23.5903 23.2843 23.2843 23.5903 22.908 23.782C22.4802 24 21.9201 24 20.8 24H3.2C2.0799 24 1.51984 24 1.09202 23.782C0.715695 23.5903 0.409734 23.2843 0.217987 22.908C0 22.4802 0 21.9201 0 20.8V3.2Z"
      fill="currentColor"
      className="icon-bg"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.64652 10.8465L7.29297 11.2L8.00008 11.9072L8.35363 11.5536L11.4995 8.40774L11.4995 16.8L11.4995 17.3L12.4995 17.3L12.4995 16.8L12.4995 8.40657L15.6465 11.5536L16.0001 11.9072L16.7072 11.2L16.3536 10.8465L12.3536 6.8465C12.1584 6.65123 11.8418 6.65123 11.6465 6.8465L7.64652 10.8465Z"
      fill="#041C1B"
    />
  </svg>
);

export { ArrowUpIcon };
